/**
 *
 * ReduxFormDropdown
 *
 */

import PropTypes from 'prop-types';
import React, { memo } from 'react';

import SharedDropdown from '../../Dropdown';

/*
  The component should be used with reduxForm Field component
  ex) <Field name="firstName" type="text" component={Dropdown}/>
*/

const Dropdown = props => {
  const {
    meta: { error, dirty },
    input: inputProps,
    ...otherProps
  } = props;

  return <SharedDropdown error={dirty && error} {...inputProps} {...otherProps} />;
};

Dropdown.propTypes = {
  /* input: passed from redux form Field component: https://redux-form.com/8.2.2/docs/api/field.md/ */
  input: PropTypes.object.isRequired,
  /* meta: metadata about state of the field,
           passed from redux form Field component: https://redux-form.com/8.2.2/docs/api/field.md/ */
  meta: PropTypes.object.isRequired,
};

export default memo(Dropdown);
